import values from 'lodash/values';
import { UiActionType } from './types';

export const toggleWorkbooksMenu = () => ({
  type: UiActionType.TOGGLE_WORKBOOKS_MENU
});

export const toggleMenu = () => ({
  type: UiActionType.TOGGLE_GLOBAL_MENU
});

export const setGlobalMenuWidth = (width = 0) => ({
  type: UiActionType.SET_GLOBAL_MENU_WIDTH,
  data: width
});

export const closeAllMenus = () => dispatch => {
  const toggles = findMenuToggleByType('all');

  toggles.forEach(menuToggle => dispatch(menuToggle(false)));
};

export const toggleMenuByType = (menuType: string) => (open: boolean) => (dispatch, getState) => {
  const triggerMenuToggle = findMenuToggleByType(menuType);
  const isOpen = getState().ui[`${menuType}MenuOpen`];

  dispatch(triggerMenuToggle(open === undefined ? !isOpen : open));
};

export const togglePageSelectorMenu = () => ({
  type: UiActionType.TOGGLE_WORKBOOK_PAGE_SELECTOR_MENU
});

const findMenuToggleByType = (menuType: string) => {
  const menuToggles = {
    global: toggleMenu,
    workbooks: toggleWorkbooksMenu,
    pageSelector: togglePageSelectorMenu
  };

  if (menuType === 'all') {
    return values(menuToggles);
  }

  if (!menuToggles[menuType]) {
    throw new Error(`Calling for unsupported menu: ${menuType}`);
  }

  return menuToggles[menuType];
};

export const toggleSlideoutMenu = () => (dispatch, getState) => {
  dispatch(toggleMenuByType('global')(!getState().ui.workbooksMenuOpen));
  if (getState().ui.workbooksMenuOpen) {
    return dispatch(toggleWorkbooksMenu());
  }
};

export const toggleOnboardingNavigationMenuOverlay = () => ({
  type: UiActionType.TOGGLE_ONBOARDING_NAVIGATION_MENU_OVERLAY
});

export const toggleSubmenu = (submenuName: string) => ({
  type: UiActionType.TOGGLE_SUBMENU,
  data: submenuName
});

export const closeMenu = (menu: any) => ({
  type: UiActionType.TOGGLE_SUBMENU,
  data: menu
});
